var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.727,
    height: 26.525,
    viewBox: "0 0 47.727 26.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M-9.79,29.1H23.52a2.211,2.211,0,0,0,2.21-2.21v.332a7.76,7.76,0,0,0,1.324-.807L33.838,33.2A1.106,1.106,0,1,0,35.4,31.64l-6.788-6.788A7.669,7.669,0,0,0,25.73,13.3V9.21A2.211,2.211,0,0,0,23.52,7H-9.79A2.211,2.211,0,0,0-12,9.21V26.894A2.211,2.211,0,0,0-9.79,29.1Zm32.2-3.316a5.526,5.526,0,1,1,5.526-5.526A5.534,5.534,0,0,1,22.415,25.789ZM-6.474,12.526H20.2a1.077,1.077,0,0,1,.57.181,7.72,7.72,0,0,0-3.762,2.029H-6.474a1.106,1.106,0,0,1-1.105-1.105A1.106,1.106,0,0,1-6.474,12.526Zm0,6.631H4.842a7.932,7.932,0,0,0-.111,1.105,7.932,7.932,0,0,0,.111,1.105H-6.474a1.106,1.106,0,0,1-1.105-1.105A1.106,1.106,0,0,1-6.474,19.157Z",
    transform: "translate(12 -7)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaSearch);
export default __webpack_public_path__ + "static/media/Social Media Search.e8837f1e83b9f94b6ab997ae20f4ace2.svg";
export { ForwardRef as ReactComponent };